import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-background px-4 py-20 sm:py-28" data-id="element-338" data-mp="3fzntrlbxjb1d">
      <div className="mx-auto max-w-6xl" data-id="element-339" data-mp="3fy2whny8ddzt">
        <div className="text-center" data-id="element-340" data-mp="3b0uepogzvbz3">
          <div className="flex justify-center gap-1 text-accent" aria-hidden="true" data-id="element-341" data-mp="3azt2vhs5mlgb">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} size={18} fill="currentColor" data-id="element-342" data-mp="31zmto83ho7my" data-mpi={i} />)}
          </div>
          <h2 className="mt-4 text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-343" data-mp="2x09x2vmtfm76">
            What Stretching Instructors Are{' '}
            <span className="italic text-primary" data-id="element-344" data-mp="2s306vdrlr6ia">Saying</span>
          </h2>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-345" data-mp="v8589t0m550o">
          {testimonials.map((item, index) => <motion.figure key={item.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-xl border border-primary/20 bg-surface p-6 shadow-card sm:p-7" data-id="element-346" data-mp="qbn3it5a96oc" data-mpi={index}>
              <div className="flex items-start justify-between" data-id="element-347" data-mp="zxr1a7zv0wat">
                <div className="flex gap-0.5 text-accent" aria-label="5 out of 5 stars" data-id="element-348" data-mp="14v99fw61z7hr">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={14} fill="currentColor" aria-hidden="true" data-id="element-349" data-mp="q6curg9hqw86" data-mpi={i} />)}
                </div>
                <span className="-mt-2 font-display text-6xl leading-none text-accent/60" aria-hidden="true" data-id="element-350" data-mp="1ivae7mpfuz2i">
                  “
                </span>
              </div>
              <blockquote className="mt-2 pb-6 font-display text-lg italic leading-8 text-foreground" data-id="element-351" data-mp="1xi91r6l6d9by">
                {item.quote}
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 border-t border-primary/15 pt-5" data-id="element-352" data-mp="1sh37h4bv9e0b">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-strong text-sm font-semibold text-primary-foreground" data-id="element-353" data-mp="1oj5ju5xquzz1">
                  {item.name.split(' ').map(part => part[0]).join('')}
                </span>
                <span className="text-sm leading-5" data-id="element-354" data-mp="14t21o362obol">
                  <span className="block font-semibold text-foreground" data-id="element-355" data-mp="14tl9gr20djow">
                    {item.name}
                  </span>
                  <span className="block text-muted-foreground" data-id="element-356" data-mp="vsnf70hdgqji">
                    {item.role} · {item.location}
                  </span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}